import React, { useEffect, useState } from 'react'
import AdministrationForm from '../UI/AdministrationForm/AdministrationForm'
import apiService from '../../Services/apiServices'
import helper from '../../Services/helper'
import mdlSaleVat from '../../Models/SaleVat.js'
import mdlPurchaseVat from '../../Models/PurchaseVat.js'
import Tabs from '../Tabs/Tabs.js'
import TabContent from '../Tabs/TabContent.js'

const Taxes = (props) => {

    const [salesType, setSalesType] = useState()
    const [purchaseType, setPurchaseType] = useState()
    const [vatLevel, setVatLevel] = useState()
    const [modal, setModal] = useState()
    const [activeTab, setActiveTab] = useState(1);


    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
      };

      const defaultValues = [
        {value: 0, label: helper().translate("NO")},
        {value: 1, label: helper().translate("YES")}
    ]

    const getSalesType = () => {
        apiService().get('salestype')
            .then((response)=> {
                if(response.success) {
                    let records = response.data.filter(f => f.id != 13).map(record => ({ value: record.id, label: helper().translate(record.name) }));
                    setSalesType(records)
                }
            })
    } 
    const getPurchaseType = () => {
        apiService().get('purchasetype')
            .then((response)=> {
                if(response.success) {
                    let records = response.data.filter(f => f.id != 0).map(record => ({ value: record.id, label: helper().translate(record.name)  }));
                    setPurchaseType(records)
                }
            })
    } 

    const purchaseHeaders = [
        { key: 'number', columnName: helper().translate("NR"), typeOfInput: 'input', required: true },
        { key: 'name', columnName: helper().translate("NAME"), typeOfInput: 'input', required: true ,type: "text"},
        { key: 'vat', name: 'vat', columnName:  helper().translate("VAT")+'%', typeOfInput: 'select', options: vatLevel, required: false },
        // { key: 'type', columnName: helper().translate("TYPE"), type: 'select', options: saleOrPurchase, required: true },
        { key: 'vatType', name: 'purchaseType', columnName: helper().translate("PURCHASE_TYPE") , typeOfInput: 'select', options: purchaseType, required: true , type: "text" },
        { key: 'defaultVat', name: 'defaultVatName', columnName:  "Default", typeOfInput: 'select', options: defaultValues, required: false  }
    ]
    const saleHeaders = [
        { key: 'number', columnName: helper().translate("NR"), typeOfInput: 'input', required: true },
        { key: 'name', columnName: helper().translate("NAME"), typeOfInput: 'input', required: true ,type: "text"},
        { key: 'vat', name: 'vat', columnName:  helper().translate("VAT")+'%', typeOfInput: 'select', options: vatLevel, required: false },
        // { key: 'type', columnName: helper().translate("TYPE"), type: 'select', options: saleOrPurchase, required: true },
        { key: 'vatType', name: 'saleType', columnName:  helper().translate("SALE_TYPE"), typeOfInput: 'select', options: salesType, required: true ,type: "text"},
        { key: 'defaultVat', name: 'defaultVatName', columnName:  "Default", typeOfInput: 'select', options: defaultValues, required: false  }
    ]

    useEffect(() => {
        getSalesType();
        getPurchaseType();
    }, [])
    

    const t = (key) => {
        return helper().translate(key);
    }

    const headers = [
        { key: 'nr', columnName: t('NR'), typeOfInput: 'dontShow'},
        { key: 'value', columnName: t('TAX'), typeOfInput: 'input', required: true }
    ]

    const model = {
        id: 0,
        value: 0
    }

    const getVatLevel = () => {
        apiService().get('vatLevel')
            .then((response) => {
                if (response.success) {
                    let records = response.data.map((record, index) => ({
                        nr: index + 1,
                        value: record.value,
                        label: record.value
                    }));
                    setVatLevel(records);
                }
            });
    }

    const performRefresh = () => {
        alert('reffff')
    }

    useEffect(() => {
        getVatLevel();
    }, [])

    useEffect(() => {
        setModal(props.modal)
    }, [props.modal]);

    let tabs = [
        {
            id: 1,
            title: t('TAXES'),
            body: <AdministrationForm new={modal} headers={headers} table="vatlevel" name={helper().translate("TAXES")} model={model} formType="modal" />,
            show: true
        },
        {
            id:2,
            title: t('PURCHASE_VAT'),
            body: <AdministrationForm headers={purchaseHeaders} table="purchaseVat" model={new mdlPurchaseVat()} name="PURCHASE_VAT"/>,
            show: true
        },
        {
            id:3,
            title: t('SALE_VAT'),
            body: <AdministrationForm headers={saleHeaders} table="saleVat" model={new mdlSaleVat()} name="SALE_VAT" />,
            show: true
        },
   

    ]

    return (
        <div className="container-fluid px-2 ">
            <div>

                
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab.id)}
            className={`nav-link mt-2 ${activeTab === tab.id ? 'active show' : ''}`} 
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div className="tab-content">
        {tabs.map(tab => (
          activeTab === tab.id && <div key={tab.id}>{tab.body}</div>
        ))}
      </div>
    </div>
        </div>
    )
    
}

export default Taxes
